import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	panelsWrapper: {
		[theme.breakpoints.up('lg')]: {
			paddingLeft: theme.subNavigation.width + 100
		}
	}
}));

function SubNavPanelsWrapper(props) {
	let classes = styles(),
		{children} = props;

	return (
		<div className={classes.panelsWrapper}>{children}</div>
	);
}

SubNavPanelsWrapper.propTypes = {
	children: PropTypes.any
};

export default SubNavPanelsWrapper;